import { render, staticRenderFns } from "./MarkdownAttachment.vue?vue&type=template&id=48ee4c88&"
import script from "./MarkdownAttachment.vue?vue&type=script&lang=js&"
export * from "./MarkdownAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports